"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiEntityRelationshipsSchema = exports.apiEntityRelationshipSchema = exports.apiEntityTypeSchema = void 0;
const zod_1 = require("zod");
const apiEntityTypeSchema = (type) => zod_1.z.literal(type);
exports.apiEntityTypeSchema = apiEntityTypeSchema;
const apiEntityRelationshipSchema = (type) => zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        type: zod_1.z.literal(type),
    }),
});
exports.apiEntityRelationshipSchema = apiEntityRelationshipSchema;
const apiEntityRelationshipsSchema = (type) => zod_1.z.object({
    data: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string().uuid(),
        type: zod_1.z.literal(type),
    })),
});
exports.apiEntityRelationshipsSchema = apiEntityRelationshipsSchema;
